import React from "react";
import { InputPadrao, LabelPadrao } from "../../components/Base";
import { InputNumero } from "../../components/InputNumero";
import formatarData from "../../Utils/formatarData";
import roundCustom from "../../Utils/RoundCustom";
import Pagamento from "../Pagamento/Pagamento";

export default function BaixaSimples({ titulos, setTitulos, pg, setPg, totais, filtros }) {
    const titulo = titulos[0];

    return <>
        <LabelPadrao noMargin>{filtros.tipo == "cp" ? "Fornecedor" : "Cliente"}</LabelPadrao>
        <InputPadrao value={titulo.pessoa} disabled />
        <div style={{ display: "flex", alignItems: "flex-end", marginBottom: 15 }}>
            <div style={{ width: "20%", marginRight: 10 }}>
                <LabelPadrao>Vencimento</LabelPadrao>
                <InputPadrao style={{ textAlign: "center" }} value={formatarData(titulo.venc).DATA} disabled />
            </div>
            <FormCustos totais={totais} onChange={v => {
                const aux = [...titulos];
                aux[0] = { ...aux[0], ...v, total: roundCustom(aux[0].valor - (!!v.desconto ? v.desconto : aux[0].desconto) + (!!v.juros ? v.juros : aux[0].juros)) };
                setTitulos(aux);
            }} />
        </div>

        <span style={{ color: "#ddd", fontSize: "0.8rem" }}>* Para informar acréscimo usar valor negativo no campo</span>
        <Pagamento totais={totais} pg={pg} setPg={setPg} tipo="financeiro" hideOperacoes />
    </>;
}

export function FormCustos({ totais, onChange, disabled }) {
    return <div style={{ display: "flex", alignItems: "flex-end", width: "100%" }}>
        <div style={{ width: "25%" }}>
            <LabelPadrao noMargin>Valor total bruto</LabelPadrao>
            <InputNumero value={totais.bruto} style={{ width: "100%" }} disabled />
        </div>

        <div style={{ width: "25%", margin: "0 10px" }}>
            <LabelPadrao noMargin>Desc./Acréscimo</LabelPadrao>
            <InputNumero value={totais.desconto} onChange={v => onChange({ desconto: roundCustom(v) })} style={{ width: "100%" }} disabled={disabled} />
        </div>

        <div style={{ width: "25%" }}>
            <LabelPadrao noMargin>Juros / Multa</LabelPadrao>
            <InputNumero value={totais.juros} onChange={v => onChange({ juros: roundCustom(v) })} style={{ width: "100%" }} disabled={disabled} />
        </div>

        <div style={{ width: "25%", marginLeft: 10 }}>
            <LabelPadrao noMargin>Valor total</LabelPadrao>
            <InputNumero value={totais.liquido} style={{ width: "100%" }} disabled />
        </div>
    </div>;
}